module.exports = __webpack_public_path__ + "img/atomic-logo.1b17f218.webp";